import React from 'react';
import { ArcStack } from '@src/core/ui';
import { Settings } from './components';

const ParameterPanel: React.FC = () => {
  return (
    <ArcStack spacing={2} p={8} pl={4.5}>
      <Settings />
    </ArcStack>
  );
};

export default ParameterPanel;